import styles from "./Profile.module.css"
import { useEffect, useState } from 'react';
import { Map, BookOpenText,  ReceiptText, User} from 'lucide-react';
import SecondaryButton from "../../components/Button/SecondaryButton/SecondaryButton";
import Navbar from "../../components/Navbar/NavbarMain/Navbar";
import Footer from "../../components/Footer/Footer";
import OrderPage from "./components/Pages/Orders/Orders";
import AccountPage from "./components/Pages/AccountSettings/Account";
import AddressPage from "./components/Pages/Addresses/Addresses";
import CatalogPage from "./components/Pages/Catalog/Catalog";
import { useUserContext } from "../../context/UserContext";
import { useLocation } from "react-router-dom";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { useOrderContext } from "../../context/OrderContext";
import { getPastOrders } from "../../services/orderService";
import { PastOrder } from "../../types/order.types";



/**
* Props for the ProfilePage component.
*/ 
interface ProfilePageProps {
    page: string
}
/**
* Profile page
* Contains all the separate pages (catalog, order history, addresses and account settings) and navigation sidebar
* 
* @param props ProfilePageProps
* @param {string} props.page - Current page
* @returns TSX.Element
*/
const ProfilePage = ({ page } : ProfilePageProps) => {
    const { t } = useTranslation(); // Translation
    const navigate = useNavigate(); // Navigate
    const screenWidth = useWindowSize(); // Screen width
    const location = useLocation(); // Location
    const { orderData } = useOrderContext();
    const { loggedIn, userData } = useUserContext(); // User Context
    const [selectedSettingsPage, setSelectedSettingsPage] = useState("user") // Handle selected profile part
    const user = userData?.subscribers?.find(sub=> sub.subscriber_id === orderData.recipient)?.name
    
    // Routing
    useEffect(() => {
    if (location.pathname.includes("/settings/order")) {
        setSelectedSettingsPage("order");
    } else if (location.pathname.includes("/settings/user")) {
        setSelectedSettingsPage("user");
    } else if (location.pathname.includes("/settings/address")) {
        setSelectedSettingsPage("address");
    } else if (location.pathname.includes("/settings/catalog")) {
        setSelectedSettingsPage("catalog");
    } else if (location.pathname === "/settings") {
        navigate("/settings/order");
    } else {
        navigate("/404");
    }
    }, [location.pathname]);



    

    if (!loggedIn) return <Navigate to="/login" />;

    return(
        <>
        {loggedIn && (
            <div className={styles.Page}>
                <div className={styles.Header}>
                    <div className={styles.Headergroup}>
                        <Navbar/>
                    </div>
                </div>
                <div className={styles.Content}>
                    <div className={styles.UserPage}>
                        {screenWidth > 1100 && (
                            <div className={styles.UserPageSidebar}>
                                <div className={styles.SideBarContent}>
                                    <div className={styles.SidebarTitle}>
                                        <div className={styles.SidebarTitleIcon}>
                                            <User />
                                        </div>
                                        <p>{user ?? "username"}</p>
                                    </div>
                                    <div className={styles.SidebarContentButtons}>
                                        <SecondaryButton
                                        text={t("account.menu.orders")}
                                        className={`${styles.SidebarContentButton} ${selectedSettingsPage === "order" ? styles.SidebarButtonActive : ""}`}
                                        onClick={()=>navigate("/settings/order")}
                                        Icon={ReceiptText}
                                        colorVariant="secondary"
                                        />
                                        <SecondaryButton
                                        text={t("account.menu.settings")}
                                        className={`${styles.SidebarContentButton} ${selectedSettingsPage === "user" ? styles.SidebarButtonActive : ""}`}
                                        onClick={()=>navigate("/settings/user")}
                                        Icon={User}
                                        colorVariant="secondary"
                                        />
                                        <SecondaryButton
                                        text={t("account.menu.addresses")}
                                        className={`${styles.SidebarContentButton} ${selectedSettingsPage === "address" ? styles.SidebarButtonActive : ""}`}
                                        onClick={()=>navigate("/settings/address")}
                                        Icon={Map}
                                        colorVariant="secondary"
                                        />
                                        <SecondaryButton
                                        text={t("account.menu.catalog")}
                                        className={`${styles.SidebarContentButton} ${selectedSettingsPage === "catalog" ? styles.SidebarButtonActive : ""}`}
                                        onClick={()=>navigate("/settings/catalog")}
                                        Icon={BookOpenText}
                                        colorVariant="secondary"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                            {/*Do samotneho objektu */}
                            <div className={styles.UserPageContent}>
                                {selectedSettingsPage === "order" && <OrderPage/>}
                                {selectedSettingsPage === "user" && <AccountPage/>}
                                {selectedSettingsPage === "address" && <AddressPage/>}
                                {selectedSettingsPage === "catalog" && <CatalogPage/>}
                            </div>
                    </div>
                </div>
                <div className={styles.Footer}>
                    <Footer/>
                </div>
            </div>
        )}
        </>
    )
}


export default ProfilePage;
